import React from 'react';
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Card} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import moment from "moment";

class DialogDetallePanelSodimac extends React.Component{
    constructor(props) {
        super(props);

        var tiempo_general = 0
        var tiempo_altillo = 0
        var tiempo_punto_venta = 0
        var tiempo_punto_venta_otros = 0
        var tiempo_exhibiciones = 0
        var tiempo_bodega = 0

        if (this.props.rowData.inicio_general !== 'SIN CONTEO' && this.props.rowData.termino_general !== 'SIN CONTEO'){
            var inicio_general = moment(this.props.rowData.inicio_general, "DD/MM/YYYY HH:mm:ss");
            var termino_general = moment(this.props.rowData.termino_general, "DD/MM/YYYY HH:mm:ss");
            tiempo_general = termino_general.diff(inicio_general, "hours", true).toFixed(2);
        }

        if (this.props.rowData.inicio_altillo !== 'SIN CONTEO' && this.props.rowData.termino_altillo !== 'SIN CONTEO'){
            var inicio_altillo = moment(this.props.rowData.inicio_altillo, "DD/MM/YYYY HH:mm:ss");
            var termino_altillo = moment(this.props.rowData.termino_altillo, "DD/MM/YYYY HH:mm:ss");
            tiempo_altillo = termino_altillo.diff(inicio_altillo, "hours",true).toFixed(2);
        }

        if (this.props.rowData.inicio_bodega !== 'SIN CONTEO' && this.props.rowData.termino_bodega !== 'SIN CONTEO'){
            var inicio_bodega = moment(this.props.rowData.inicio_bodega, "DD/MM/YYYY HH:mm:ss");
            var termino_bodega = moment(this.props.rowData.termino_bodega, "DD/MM/YYYY HH:mm:ss");
            tiempo_bodega = termino_bodega.diff(inicio_bodega, "hours",true).toFixed(2);
        }

        if (this.props.rowData.inicio_punto_venta !== 'SIN CONTEO' && this.props.rowData.termino_punto_venta !== 'SIN CONTEO') {
            var inicio_punto_venta = moment(this.props.rowData.inicio_punto_venta, "DD/MM/YYYY HH:mm:ss");
            var termino_punto_venta = moment(this.props.rowData.termino_punto_venta, "DD/MM/YYYY HH:mm:ss");
            tiempo_punto_venta = termino_punto_venta.diff(inicio_punto_venta, "hours", true).toFixed(2)
        }

        if (this.props.rowData.inicio_punto_venta_otros !== 'SIN CONTEO' && this.props.rowData.termino_punto_venta_otros !== 'SIN CONTEO') {
            var inicio_punto_venta_otros = moment(this.props.rowData.inicio_punto_venta_otros, "DD/MM/YYYY HH:mm:ss");
            var termino_punto_venta_otros = moment(this.props.rowData.termino_punto_venta_otros, "DD/MM/YYYY HH:mm:ss");
            tiempo_punto_venta_otros = termino_punto_venta_otros.diff(inicio_punto_venta_otros, "hours",true).toFixed(2)
        }
        if (this.props.rowData.inicio_exhibiciones !== 'SIN CONTEO' && this.props.rowData.termino_exhibiciones !== 'SIN CONTEO') {
            var inicio_exhibiciones = moment(this.props.rowData.inicio_exhibiciones, "DD/MM/YYYY HH:mm:ss");
            var termino_exhibiciones = moment(this.props.rowData.termino_exhibiciones, "DD/MM/YYYY HH:mm:ss");
            tiempo_exhibiciones = termino_exhibiciones.diff(inicio_exhibiciones, "hours",true).toFixed(2)
        }

        this.state={
            rowData: this.props.rowData,
            tiempo_general: tiempo_general,
            tiempo_altillo: tiempo_altillo,
            tiempo_bodega: tiempo_bodega,
            tiempo_punto_venta: tiempo_punto_venta,
            tiempo_punto_venta_otros: tiempo_punto_venta_otros,
            tiempo_exhibiciones: tiempo_exhibiciones,
        }

    }

    render() {
        return(
            <Dialog
                open={true}
                fullWidth
                maxWidth="md"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Datos adicionales</DialogTitle>
                <DialogContent>
                    <Grid container spacing={1} style={{ padding:5}}>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Typography sx={{fontSize: 14}} >
                                        Analista Responsable: {this.state.rowData.analista_responsable}
                                    </Typography>
                                    <Typography  sx={{fontSize: 14}} >
                                        Validador: {this.state.rowData.validador}
                                    </Typography>
                                    <Typography  sx={{fontSize: 14}} >
                                        Coordinador: {this.state.rowData.coordinador}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Typography sx={{fontSize: 14}} >
                                        Hora Prevariance: {this.state.rowData.hora_prevariance}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} >
                                        Hora Variance: {this.state.rowData.hora_variance}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} >
                                        Hora Variance Efectivo: {this.state.rowData.hora_variance_efectivo}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        General
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Inicio: {this.state.rowData.inicio_general}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Termino: {this.state.rowData.termino_general}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_general}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_general * 100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Bodega
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Inicio: {this.state.rowData.inicio_bodega}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Termino: {this.state.rowData.termino_bodega}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_bodega}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_bodega*100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Altillo
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Inicio: {this.state.rowData.inicio_altillo}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Termino: {this.state.rowData.termino_altillo}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_altillo}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_altillo * 100).toFixed(2)}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Inicio Validación: {(this.state.rowData.inicio_validacion_altillo)}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Termino Validación: {(this.state.rowData.termino_validacion_altillo)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Punto de Venta
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Inicio: {this.state.rowData.inicio_punto_venta}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Termino: {this.state.rowData.termino_punto_venta}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_punto_venta}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_punto_venta * 100).toFixed(2)}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Inicio Validación: {(this.state.rowData.inicio_validacion_punto_venta)}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Termino Validación: {(this.state.rowData.termino_validacion_punto_venta)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Punto de Venta (Otros)
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Inicio: {this.state.rowData.inicio_punto_venta_otros}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Termino: {this.state.rowData.termino_punto_venta_otros}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_punto_venta_otros}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_punto_venta_otros *100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Exhibiciones
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Inicio: {this.state.rowData.inicio_exhibiciones}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Termino: {this.state.rowData.termino_exhibiciones}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_exhibiciones}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_exhibiciones*100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

}

export default DialogDetallePanelSodimac;